import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  useMediaQuery,
  useTheme,
  Tooltip,
} from "@mui/material"
import {
  Menu as MenuIcon,
  Add as AddIcon,
  Person as PersonIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material"
import { useAuth } from "../../contexts/AuthContext"
import { Link } from "react-router-dom"

function TopBar({ onMenuClick, drawerWidth, isCollapsed, onToggleCollapse }) {
  const { user, logout } = useAuth()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        transition: "width 0.2s ease-in-out, margin-left 0.2s ease-in-out",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* Mobile drawer toggle */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Desktop Sidebar Collapse Toggle */}
          {/* <Tooltip title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}>
            <IconButton
              color="inherit"
              onClick={onToggleCollapse}
              sx={{
                display: { xs: "none", sm: "flex" },
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.25)" },
                p: 0.75,
              }}
            >
              {isCollapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
            </IconButton>
          </Tooltip> */}

          {/* Logo and App Name */}
          <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
            <Typography variant="h6" noWrap component="div" sx={{ fontWeight: "bold" }}>
              Fiscale
            </Typography>
          </Box>
        </Box>

        {/* Action Buttons & User Profile */}
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {!isMobile && (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                color="inherit"
                startIcon={<PersonIcon />}
                to="/add-client"
                component={Link}
                variant="outlined"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              >
                Add Client
              </Button>
              <Button
                component={Link}
                color="inherit"
                startIcon={<AddIcon />}
                variant="outlined"
                to="/add-job"
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.3)",
                  "&:hover": {
                    borderColor: "rgba(255, 255, 255, 0.5)",
                  },
                }}
              >
                Add Job
              </Button>
            </Box>
          )}

          {/* User Info */}
          <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
            <Typography variant="body2" sx={{ mr: 1 }}>
              {user?.name} ({user?.role})
            </Typography>
            <Button color="inherit" onClick={logout} size="small">
              Logout
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default TopBar
